import {useContext} from 'react';

import {QuizContext} from '../contexts';

export const useQuiz = () => {
  return useContext(QuizContext);
};
